import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {Observable, ReplaySubject} from "rxjs";
import {AffiliateCode} from "../../../shared/interface/affiliateCode";
import {UserPermissions} from "../../../shared/interface/user-permissions";
import {AuthService} from "../../../shared/services/auth.service";
import {MatDialog} from "@angular/material/dialog";
import {LicensedAgentService} from "../../../shared/services/licensed-agent.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {Router} from "@angular/router";
import {
  AFFILIATE_CODE_STATUS_ACTIVE,
  AFFILIATE_CODE_STATUS_INACTIVE,
  DictService
} from "../../../shared/services/dict.service";
import {takeUntil} from "rxjs/operators";
import {AffiliateCodeAddDialogComponent} from "../affiliate-code-add-dialog/affiliate-code-add-dialog.component";
import {ConfirmDialogComponent} from "../../../shared/components/confirm-dialog/confirm-dialog.component";
import {HttpErrorResponse} from "@angular/common/http";
import {AffiliateCodeService} from "../../../shared/services/affiliate-code.service";
import {linkAffiliate} from "../../../../environments/environment";

@Component({
  selector: 'app-affiliate-code-details-view',
  templateUrl: './affiliate-code-details-view.component.html',
  styleUrls: ['./affiliate-code-details-view.component.scss']
})
export class AffiliateCodeDetailsViewComponent implements OnInit, OnDestroy {
  @Input() affiliateCode: Observable<AffiliateCode>;
  @Output() modifyClicked = new EventEmitter<any>();


  readonly AFFILIATE_CODE_STATUS_ACTIVE = AFFILIATE_CODE_STATUS_ACTIVE;
  readonly  AFFILIATE_CODE_STATUS_INACTIVE = AFFILIATE_CODE_STATUS_INACTIVE;

  // public link: string[] = ['http://localhost:8000/partnerzy/linki-afiliacyjne/szczegoly/testowylikn2=',
  //   'http://localhost:8000/partnerzy/linki-afiliacyjne/szczegoly/testowylikn1=',
  //   'http://localhost:8000/partnerzy/linki-afiliacyjne/szczegoly/testowylikn='];


  userPermissions: ReplaySubject<UserPermissions>;
  affiliateCodeObject?: AffiliateCode;
  readonly  link = linkAffiliate.production;
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private auth: AuthService,
    private dialog: MatDialog,
    private licensedAgentService: LicensedAgentService,
    private snack: MatSnackBar,
    private router: Router,
    private dictService: DictService,
    private affiliateCodeService: AffiliateCodeService,
  ) {
    this.userPermissions = auth.getUserPermissions();
  }

  ngOnInit(): void {
    this.affiliateCode
      .pipe(takeUntil(this.destroyed$))
      .subscribe((affiliateCode: AffiliateCode) => {
        this.affiliateCodeObject = affiliateCode;
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  modify(): void {
    const dialogRef = this.dialog.open(AffiliateCodeAddDialogComponent, {
      width: '55%',
      data: {
        affiliateCodeObject: this.affiliateCodeObject,
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      this.modifyClicked.emit();
    });
  }

  delete(): void{
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '500px',
      data: {text: 'Czy na pewno chcesz zablokować kod? Po zablokowaniu kod nie będzie uprawniał do zniżek.'},
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.affiliateCodeService.delete(this.affiliateCodeObject.uuid)
          .subscribe(() => {
            this.snack.open('Pomyślnie zablokowano kod', '', {duration: 2000});
            this.modifyClicked.emit();
          }, (error: HttpErrorResponse) => {
            this.snack.open('Podczas dezaktywacja kod wystąpił błąd', error.status.toString(), {
              duration: 2000,
            });

            if (error.status === 400) {
              this.snack.open(error.error.error.text, null, {duration: 4000});
            }
          });
      }
    });
  }

  restore(): void{
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '500px',
      data: {text: 'Czy na pewno chcesz odblokować kod?'},
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.affiliateCodeService.restore(this.affiliateCodeObject.uuid)
          .subscribe(() => {
            this.snack.open('Pomyślnie odblokowano kod', '', {duration: 2000});
            this.modifyClicked.emit();
          }, (error: HttpErrorResponse) => {
            this.snack.open('Podczas odblokowywana kodu wystąpił błąd', error.status.toString(), {
              duration: 2000,
            });

            if (error.status === 400) {
              this.snack.open(error.error.error.text, null, {duration: 4000});
            }
          });
      }
    });
  }

}
